"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.inRange = void 0;
/**
 * Checks if n is between start and end (inclusive of both ends.)
 *
 * @param n The number to check.
 * @param start The start of the range (inclusive).
 * @param end The end of the range (inclusive).
 * @returns Returns true if n is in the range, otherwise false.
 */
const inRange = (n, start, end) => n >= start && n <= end;
exports.inRange = inRange;